 import { BrowserModule } from '@angular/platform-browser';
 import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
 import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
 import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
 import { registerLocaleData } from '@angular/common';
 import localeNL from '@angular/common/locales/nl';
 registerLocaleData(localeNL);

 import { FormsModule } from '@angular/forms';
 import { AppComponent } from './app.component';
 import { NgxSpinnerModule} from 'ngx-spinner'
 import { AppRoutingModule } from './app-routing.module';
 import { ValidationModule } from '../lib/validation/validation.module';
 import { ServicesModule } from '../lib/services/services.module';
 import { UiModule } from '../lib/ui/ui.module';

 import { FormInputComponent } from './form-input/form-input.component';
 import { FormInputCurrencyComponent } from './form-input-currency/form-input-currency.component';
 import { VerzekerdeComponent } from './verzekerde/verzekerde.component';
 import { AdviesComponent } from './advies/advies.component';
 import { BevestigingComponent } from './bevestiging/bevestiging.component';
 import { PremiumCardComponent } from './premium-card/premium-card.component';
 import { NgSelectModule} from '@ng-select/ng-select';
 import { provideHttpClient } from '@angular/common/http';

 @NgModule({
     declarations: [
         AppComponent,
         FormInputComponent,
         FormInputCurrencyComponent,
         VerzekerdeComponent,
         AdviesComponent,
         BevestigingComponent,
         PremiumCardComponent,
     ],
     imports: [
         BrowserModule,
         BrowserAnimationsModule,
         FormsModule,
         AppRoutingModule,
         NgSelectModule,
         ValidationModule,
         ServicesModule,
         UiModule,
         NgxSpinnerModule,
        ],
     schemas: [CUSTOM_ELEMENTS_SCHEMA],
     providers: [
        provideAnimationsAsync(),
        { provide: LOCALE_ID, useValue: "nl" },
        provideHttpClient()
     ],
     bootstrap: [AppComponent]
 })
 export class AppModule { }
